export default __webpack_public_path__ + "static/media/litho-demo-creative-portfolio.42d19fa9.jpg";